// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__-yTv6","primary":"Button_primary__1E8ax","secondary":"Button_secondary__vZOAZ","Hide":"Button_Hide__vajVA"};